// extracted by mini-css-extract-plugin
export var modalFooter = "_qx-0";